import { Widget, mk_widget, Action } from "widgets-for-react";
import * as React from "react";
import { PublicSiteState } from "../../public_site.main.mod";
import NavItems from "./nav_items";
import { AppState } from "../../cms/state/types.gen";
import { PublicSiteCustomRoutes } from "../custom_pages/types.mod";
import { gtmPush } from "../../../helpers";
import { Icons } from "./icons";
import FooterColumns from "./footer_columns";

export const footer: (
  s: AppState<PublicSiteState, PublicSiteCustomRoutes>
) => Widget<
  Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
> = props =>
  mk_widget({
    run: o => (
      <>
      <footer className="footer">
        <div className="footer__inner">
          <FooterColumns location="footer_columns" />
          <div className="footer__bottom">
            <div className="footer__bottom-inner container container--l">
              <div className="footer__column column column--left">
                <NavItems location='footer' cssClass={'bottom'} hasActiveState={false} 
                  before={
                    <li className="nav__item nav__item--footer footer__copyright">
                        &copy; Copyright Hypotrust
                    </li>
                  }

                  after={
                    <li className="nav__item nav__item--footer">
                      <a 
                        href="#cookiesettings"
                        onClick={_ => {
                          o(s => ({ 
                            ...s, 
                            state: { 
                              ...s.state, 
                              cookiebar: {
                                ...s.state.cookiebar,
                                cookiebar: (s.state.cookiebar.cookiebar == 'open' ? 'closed' : 'open')  
                              }
                            }
                          })) 
                        }}
                        className={`nav__link nav__link--footer`}
                      >
                        <span className="nav__label">Cookievoorkeuren</span>
                      </a>
                    </li>
                  } />
              </div>
              <div className="footer__column column column--right">
                <ul className="footer__icons icons">
                  <li className="icons__item">
                    <a className="icons__link" href="https://www.facebook.com/Hypotrust" target="_blank" onClick={_ => {
                      gtmPush({ category: 'Social', action: 'Click', label: 'Facebook' })
                    }}>
                      <svg className="icons__icon icon icon--facebook" width="24px" height="24px" aria-hidden="true">
                        <use xlinkHref="#icon--facebook"/>
                      </svg>
                      <span className="sr-text">facebook link</span>
                    </a>
                  </li>
                  <li className="icons__item">
                    <a className="icons__link" href="https://www.instagram.com/hypotrust/?hl=nl" target="_blank" onClick={_ => {
                      gtmPush({ category: 'Social', action: 'Click', label: 'Instagram' })
                    }}>
                      <svg className="icons__icon icon icon--instagram" width="24px" height="24px" aria-hidden="true">
                        <use xlinkHref="#icon--instagram"/>
                      </svg>
                      <span className="sr-text">instagram link</span>
                    </a>
                  </li>
                  <li className="icons__item">
                    <a className="icons__link" href="https://www.linkedin.com/company/hypotrust/" target="_blank" onClick={_ => {
                      gtmPush({ category: 'Social', action: 'Click', label: 'Instagram' })
                    }}>
                      <svg className="icons__icon icon icon--instagram" width="18px" height="24px" aria-hidden="true">
                        <use xlinkHref="#icon--linkedin"/>
                      </svg>
                      <span className="sr-text">linkedin link</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <Icons />
      </>
    )
  });
  


// WEBPACK FOOTER //
// ./Client/components/public_site/templates/footer.mod.tsx